export default "__VITE_ASSET__g$Iv_uqP__"